<template>
  <Icon>
    <svg slot="svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <defs>
        <path d="M18.4,11 L5.6,11 C5.048,11 5,11.447 5,12 C5,12.553 5.048,13 5.6,13 L18.4,13 C18.952,13 19,12.553 19,12 C19,11.447 18.952,11 18.4,11 Z M18.4,15 L5.6,15 C5.048,15 5,15.447 5,16 C5,16.553 5.048,17 5.6,17 L18.4,17 C18.952,17 19,16.553 19,16 C19,15.447 18.952,15 18.4,15 Z M5.6,9 L18.4,9 C18.952,9 19,8.553 19,8 C19,7.447 18.952,7 18.4,7 L5.6,7 C5.048,7 5,7.447 5,8 C5,8.553 5.048,9 5.6,9 Z" id="path-1-menu"></path>
      </defs>
      <g id="icons/menu" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <rect id="Bounding-Box" x="0" y="0" width="24" height="24"></rect>
        <mask id="mask-2-menu" fill="white">
          <use xlink:href="#path-1-menu"></use>
        </mask>
        <use id="Shape" fill="#000000" fill-rule="nonzero" xlink:href="#path-1-menu"></use>
        <g id="Mixin/Fill/Black" mask="url(#mask-2-menu)" fill="#000000">
          <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
        </g>
      </g>
    </svg>
  </Icon>
</template>

<script>
import Icon from './icon';

export default {
  name: 'DsMenuIcon',
  components: {
    Icon
  }
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// ../panel-theme/src/js/icons/ds-menu-icon.vue